var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
var DEFAULT_ERROR_MESSAGE = "Hubo inconvenientes al procesar la solicitud, por favor contacte con la aseguradora";
var getErrorArray = function (error) {
    var _a;
    // Intentar primero con estructura anidada: error.error.errors
    if (((_a = error.error) === null || _a === void 0 ? void 0 : _a.errors) &&
        Array.isArray(error.error.errors) &&
        error.error.errors.length > 0) {
        return error.error.errors;
    }
    var errorData = error.errors || error.error;
    return Array.isArray(errorData) && errorData.length > 0 ? errorData : null;
};
export var showErrorToast = function (error, setSeeToastFunction, tl, showMessageApi, interpolationValues) {
    if (!error)
        return;
    console.log("error", error);
    var message = DEFAULT_ERROR_MESSAGE;
    var errorArray = getErrorArray(error);
    if (errorArray) {
        message = showMessageApi
            ? errorArray.map(function (err) { return err.message; }).join("\n")
            : errorArray
                .map(function (err) {
                return tl("errors.".concat(err.message), __assign({ defaultValue: err.message }, interpolationValues));
            })
                .join("\n");
    }
    else if (showMessageApi && error.message) {
        message = error.message;
    }
    else if (error.error &&
        typeof error.error === "object" &&
        !Array.isArray(error.error) &&
        typeof error.error.error === "string") {
        message = error.error.error;
    }
    setSeeToastFunction({
        show: true,
        message: message,
        type: typeAlert.error,
    });
    // Limpiar todas las estructuras posibles
    if (error.errors)
        error.errors = [];
    if (error.error) {
        if (Array.isArray(error.error)) {
            error.error = [];
        }
        else if (typeof error.error === "object" && "errors" in error.error) {
            error.error.errors = [];
        }
    }
};
